import { utils } from '@costar/theme-ui';

function multiSelectTextResolver () {
  var resolveText = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function (v) {
    return "".concat(v);
  };
  var flattenSelectionOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return function (selection) {
    if (utils.isNotEmptyObject(flattenSelectionOptions) && selection.length > 0) {
      var curSelection = flattenSelectionOptions[selection[0]];
      if (!curSelection) {
        return "".concat(selection);
      }
      if (typeof curSelection === 'string') {
        return "".concat(curSelection).concat(selection.length > 1 ? ' +' + (selection.length - 1) : '');
      } else {
        return "".concat(curSelection.label).concat(selection.length > 1 ? ' +' + (selection.length - 1) : '');
      }
    }
    return resolveText(selection);
  };
}

export default multiSelectTextResolver;
//# sourceMappingURL=multi-select-text-resolver.esm.js.map
